<template>
  <div class="container-fluid">
    <b-form @submit="onSubmit">
      <div class="contents">
        <div class="row g-0 table-type header-col">
          <div class="col-sm-5 col-md-4 required">
            {{ $t("title.brandroom.brand_name") }}
          </div>
          <div class="col-sm-7 col-md-8">
            <select aria-label="SelectBrand " v-model="form.searchshopbrandno">
              <option value="0">
                {{ $t("filter.brandroom.choosebrand") }}
              </option>
              <option
                :value="br.brandno"
                v-for="(br, index) in form.searchshopbrandlist"
                :key="index"
              >
                {{ br.brandname }}
              </option>
            </select>
          </div>

          <div class="col-sm-5 col-md-4 required">
            {{ $t("title.main.title") }}
          </div>
          <div class="col-sm-7 col-md-8">
            <input
              type="text"
              :placeholder="$t('alert.fitting.enter_title')"
              required
              v-model="form.noticetitle"
            />
          </div>
          <div class="col-sm-5 col-md-4 required">
            {{ $t("title.common.sort") }}
          </div>
          <div class="col-sm-7 col-md-8">
            <select v-model="form.noticecategory">
              <option value="2">{{ $t("filter.brandroom.as") }}</option>
              <option value="3">{{ $t("filter.brandroom.proposal") }}</option>
            </select>
          </div>

          <div class="col-sm-5 col-md-4">
            {{ $t("title.brandroom.attachmentdq") }}
          </div>
          <div class="col-sm-7 col-md-8">
            <b-form-file
              v-model="file1"
              ref="file1"
              :state="Boolean(file1)"
              :placeholder="$t('text.setting.select_file_or_drop')"
              :drop-placeholder="$t('text.setting.drop_it_here')"
              @change="fileSelect"
            >
            </b-form-file>
            <article class="article-attach" v-if="form.as_oldfilenametxt">
              {{ $t("title.brandroom.previousfilesdq") }}
              <a :href="form.as_filepath | get_img">
                <!-- <i class="material-icons-outlined">file_download</i> -->
                <span>{{ form.as_oldfilenametxt }}</span>
              </a>
            </article>
          </div>
          <div class="col-sm-5 col-md-4 required">
            {{ $t("title.brandroom.inqury_content") }}
          </div>
          <div class="col-sm-7 col-md-8">
            <ckeditor
              tag-name="textarea"
              ref="cktext"
              v-model="form.content"
              :config="editorConfig"
            />
          </div>
        </div>
        <!-- table-type -->

        <div class="btn-bottom-wrapper">
          <b-button
            size="xl"
            variant="outline-primary"
            aria-label="List"
            @click="
              $router.push({
                name: 'CustomerList',
                query: { category: $route.query.category },
              })
            "
            >{{ $t("button.brandroom.list") }}</b-button
          >
          <b-button
            size="xl"
            variant="primary"
            aria-label="Registration"
            type="submit"
            >{{ noticeno ? "Modify" : "Registration" }}</b-button
          >
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import "@/filter/common";
import ax from "@/api/fitting";

export default {
  name: "MiniGameWrite",
  data() {
    return {
      form: {
        brandno: "0",
        noticetitle: "",
        noticecategory: "2",
        content: "",
        as_filename: "",
        as_filenametxt: "",
        searchshopbrandno: "0",
        searchshopbrandlist: [],
      },
      editorConfig: {
        versionCheck: false,
        // The configuration of the editor.
        height: "200px",
        language: "en",
        toolbar: [
          ["Source"],
          ["Link"],
          ["Styles", "Format", "Font", "FontSize"],
          ["Bold", "Italic"],
          ["Undo", "Redo"],
          ["About"],
        ],
      },
      as_oldfilenametxt: "",
      file1: null,
      noticeno: this.$route.params.noticeno || 0,
      noticeinfo: {},
    };
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();

      if (this.form.searchshopbrandno == "0") {
        alert(this.$i18n.t("alert.fitting.select_brand_name"));
        return false;
      }
      if (this.form.noticetitle === "") {
        alert(this.$i18n.t("alert.fitting.enter_title"));
        return false;
      }
      if (this.form.content === "") {
        alert(this.$i18n.t("alert.fitting.enter_inquiry"));
        return false;
      }

      ax.post_custormerwrite(this.form, this.noticeno, (flag, data) => {
        if (flag) {
          alert(data.message);
          this.$router.push({
            path: "/fitting/CustomerView/" + data.noticeno,
          });
        } else {
          alert(data.message);
        }
      });
    },
    fileSelect(e) {
      // alert(e.dataTransfer.files[0]);
      if (e.dataTransfer) {
        this.form.as_filename = e.dataTransfer.files[0];
      } else {
        this.form.as_filename = e.target.files[0];
      }
    },
    get_custormerview() {
      ax.get_custormerview(this.noticeno, {}, (flag, data) => {
        console.log(flag, data);
        this.form.noticetitle = data.noticeinfo.noticetitle;
        this.form.noticecategory = data.noticeinfo.category;
        this.form.content = data.noticeinfo.content;
        this.form.as_filepath = data.noticeinfo.as_filepath;

        this.form.as_filename = data.noticeinfo.as_filename;
        this.form.as_filenametxt = data.noticeinfo.as_filename;
        this.form.as_oldfilenametxt = data.noticeinfo.as_filename;
        this.form.searchshopbrandno = data.noticeinfo.brandno;

        if (!flag) {
          alert(data);
        }
      });
    },
    getBrandlist() {
      ax.get_brandlist((flag, data) => {
        console.log(flag, data);
        if (flag) {
          this.form.searchshopbrandlist = data.brandlist;
        } else {
          this.$notify({
            group: "alert",
            type: "warn",
            text: data,
            duration: 5000,
            speed: 1000,
          });
        }
      });
    },
  },
  created() {
    this.getBrandlist();

    if (this.noticeno) {
      this.get_custormerview();
    }
  },
};
</script>
<style scoped></style>
